import { render, staticRenderFns } from "./date-customer.vue?vue&type=template&id=1d49bcc2&scoped=true&"
import script from "./date-customer.vue?vue&type=script&lang=js&"
export * from "./date-customer.vue?vue&type=script&lang=js&"
import style0 from "./date-customer.vue?vue&type=style&index=0&id=1d49bcc2&prod&lang=scss&scoped=true&"
import style1 from "./date-customer.vue?vue&type=style&index=1&id=1d49bcc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49bcc2",
  null
  
)

export default component.exports